let template = `<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      {{title}}{{#if target}}:{{/if}}
      <span class="secondary-text">{{target}}</span>
      <button class="btn-close" data-dismiss="modal">X</button>
      <div class="modal-alert-container">
        <div class="alert"></div>
      </div>
    </div>
    <form>
      <div class="modal-body text-center">
      {{{body}}}
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" data-dismiss="modal">Cancel</button>
        <button type="submit" class="btn btn-primary">{{primary_action}}</button>
      </div>
    </form>
  </div>
</div>`;


import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';

    var ConfirmationDialog = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        ui: {
            submitButton: 'button[type="submit"]'
        },
        events: {
            'submit form': 'onSubmit',
        },
        initialize: function(options) {
            this.callback = options.callback;
            this.destroyOnClose();
        },
        templateContext: function() {
            return this.options.message;
        },
        onSubmit: function(e) {
            e.preventDefault();
            this.ui.submitButton.prop('disabled', true);

            if (this.callback) {
                this.callback();
                if (!this.options.waitToClose) {
                    this.closeDialog();
                }
            } else {
                this.closeDialog();
            }
        }
    });

    export default ConfirmationDialog;

